import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class LeadsService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.LEADS = '/api/leads';

        this.GET_BY_ID = '/{id}';
        this.GET_ALL = '/get-list';
        this.GET_BY_FILTER = '/get-list/filter';
        this.GENERATE_AI_SUMMERY = '/generate/ai/summery';
        this.REPORT_EXPORT = '/generate-report';
        this.UPDATE = "/update";
        this.UPDATE_STATUS = '/update/status';
        this.UPDATE_ASSIGNEE = '/update/assignee';
        this.UPDATE_COMMENTS = '/update/comments';
        this.UPDATE_PINNED_COMMENT = '/update/pin-comment';
        this.CREATE = '/create';
        this.DELETE = '/delete';
    }

    async getById(id) {
        try {
            let url = window.location.origin + this.LEADS + this.GET_BY_ID;
            url = url
                .replace('{id}', id);
            const contactUs = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return contactUs;
        } catch(err) {
            console.log(err);
        }
    }

    async getFilteredList(filter) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.LEADS + this.GET_BY_FILTER;
        try {
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken,
                },
                body: JSON.stringify(filter),
            }).then(data => data.json())
                .then(response => {
                    if (response.error !== undefined) {
                        if (response.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', response.uuid);
                        }
                    }
                    return response;
                });
        } catch (err) {
            console.error(err);
        }
    }

    async generateAiSummery(body) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.LEADS + this.GENERATE_AI_SUMMERY;
        try {
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken,
                },
                body: JSON.stringify(body),
            }).then(data => data.json())
                .then(response => {
                    if (response.error !== undefined) {
                        if (response.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', response.uuid);
                        }
                    }
                    return response;
                });
        } catch (err) {
            console.error(err);
        }
    }

    async exportReport(filter) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.LEADS + this.REPORT_EXPORT;
        try {
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken,
                },
                body: JSON.stringify(filter),
            }).then(data => data.json())
                .then(response => {
                    if (response.error !== undefined) {
                        if (response.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', response.uuid);
                        }
                    }
                    return response;
                });
        } catch (err) {
            console.error(err);
        }
    }

    async createLeads(leadsMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.LEADS + this.CREATE;
        try {
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken,
                },
                body: JSON.stringify(leadsMap),
            }).then(data => data.json())
                .then(response => {
                    if (response.error !== undefined) {
                        if (response.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', response.uuid);
                        }
                    }
                    return response;
                });
        } catch (err) {
            console.error(err);
        }
    }

    async updateLeads(status) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.LEADS + this.UPDATE;
        try {
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken,
                },
                body: JSON.stringify(status),
            }).then(data => data.json())
                .then(response => {
                    if (response.error !== undefined) {
                        if (response.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', response.uuid);
                        }
                    }
                    return response;
                });
        } catch (err) {
            console.error(err);
        }
    }

    async updateAssignee(assigneeBody) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.LEADS + this.UPDATE_ASSIGNEE;
        try {
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken,
                },
                body: JSON.stringify(assigneeBody),
            }).then(data => data.json())
                .then(response => {
                    if (response.error !== undefined) {
                        if (response.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', response.uuid);
                        }
                    }
                    return response;
                });
        } catch (err) {
            console.error(err);
        }
    }

    async updateStatus(status) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.LEADS + this.UPDATE_STATUS;
        try {
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken,
                },
                body: JSON.stringify(status),
            }).then(data => data.json())
                .then(response => {
                    if (response.error !== undefined) {
                        if (response.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', response.uuid);
                        }
                    }
                    return response;
                });
        } catch (err) {
            console.error(err);
        }
    }

    async updateComment(comments) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.LEADS + this.UPDATE_COMMENTS;
        try {
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken,
                },
                body: JSON.stringify(comments),
            }).then(data => data.json())
                .then(response => {
                    if (response.error !== undefined) {
                        if (response.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', response.uuid);
                        }
                    }
                    return response;
                });
        } catch (err) {
            console.error(err);
        }
    }

    async updatePinnedComment(updateMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.LEADS + this.UPDATE_PINNED_COMMENT;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(updateMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if (data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async deleteById(id) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.LEADS + this.DELETE;
        let bodyObj = {
            id: id
        }
        try {
            const deleteLeads = this.fetch(url,{
                method:'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(bodyObj)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                        }
                        return data;
                    })
            return deleteLeads;
        } catch (err) {
            console.error(err);
        }
    }
}

export default LeadsService;
